export const setPendingInterventions = (interventions) => ({
  type: "SET_PENDING_INTERVENTIONS",
  payload: interventions,
});

export const setPlannedInterventions = (interventions) => ({
  type: "SET_PLANNED_INTERVENTIONS",
  payload: interventions,
});

export const setCanceledInterventions = (interventions) => ({
  type: "SET_CANCELED_INTERVENTIONS",
  payload: interventions,
});

export const setRefusedInterventions = (interventions) => ({
  type: "SET_REFUSED_INTERVENTIONS",
  payload: interventions,
});

export const setFinishedInterventions = (interventions) => ({
  type: "SET_FINISHED_INTERVENTIONS",
  payload: interventions,
});

export const fetchPendingInterventions  = (token) =>
  fetchInterventionsByStatus(token, "pending", setPendingInterventions);

export const fetchPlannedInterventions = (token) =>
  fetchInterventionsByStatus(token, "planned", setPlannedInterventions);

export const fetchCanceledInterventions = (token) =>
  fetchInterventionsByStatus(token, "canceled", setCanceledInterventions);

export const fetchRefusedInterventions  = (token) =>
  fetchInterventionsByStatus(token, "refused", setRefusedInterventions);
export const fetchFinishedInterventions  = (token) =>
  fetchInterventionsByStatus(token, "done", setFinishedInterventions);

export const sendIntervention = (formData, token) => {
  const apiUrl = process.env.REACT_APP_API_URL;

  return async (dispatch) => {
    try {
      const response = await fetch(`${apiUrl}/api/interventions/new`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Erreur lors de l’envoi de l'intervention");
      }

      await dispatch(fetchPendingInterventions(token));

      return data;
    } catch (error) {
      console.error("Erreur envoi intervention:", error);
      throw error;
    }
  };
};
export const acceptIntervention = (token, interventionId) => {
  const apiUrl = process.env.REACT_APP_API_URL;

    return async (dispatch) => {
      const formData = new FormData();
      formData.append("idIntervention",interventionId);
    
    try {
      const response = await fetch(`${apiUrl}/api/interventions/accept`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Erreur lors de l'acceptation de l'intervention");
      }

      await dispatch(fetchPendingInterventions(token));
      await dispatch(fetchPlannedInterventions(token));

      return data;
    } catch (error) {
      console.error("Erreur accept intervention:", error);
      throw error;
    }
  };

}

export const finishIntervention = (token, formData) => {
  const apiUrl = process.env.REACT_APP_API_URL;

  return async (dispatch) => {
    const res = await fetch(
      `${apiUrl}/api/interventions/finish`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      }
    );

    const data = await res.json();
    if (!res.ok) throw new Error(data.error);

    await dispatch(fetchPlannedInterventions(token));
    await dispatch(fetchFinishedInterventions(token));

    return data;
  };
};


const fetchInterventionsByStatus = (token, status, action) => {
  const apiUrl = process.env.REACT_APP_API_URL;

  return async (dispatch) => {
    try {
      const response = await fetch(`${apiUrl}/api/interventions/${status}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Erreur lors du chargement des interventions");
      }

      const interventions = data.interventions || [];
      dispatch(action(interventions));
      return interventions;
    } catch (error) {
      console.error(`Erreur fetch${status}Interventions:`, error);
      throw error;
    }
  };
};
